import { render } from "./Tabbar.vue?vue&type=template&id=35d61eee&scoped=true&ts=true"
import script from "./Tabbar.vue?vue&type=script&lang=ts"
export * from "./Tabbar.vue?vue&type=script&lang=ts"

import "./Tabbar.vue?vue&type=style&index=0&id=35d61eee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d61eee"]])

export default __exports__